import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

import AdventTextDoor from './textDoor';

/** Sponsor door: the greeting layout plus a copyable discount code. */
@observer
class AdventSponsorDoor extends Component {
    constructor(props) {
        super(props);
        this.state = { copied: false };
    }

    copy = async (code) => {
        try {
            await navigator.clipboard.writeText(code);
            this.setState({ copied: true });
        } catch (e) {
            this.setState({ copied: false });
        }
    }

    render() {
        const { door = {} } = this.props;
        const sponsor = door.content?.sponsor || {};
        const { copied } = this.state;
        return (
            <AdventTextDoor {...this.props}>
                {sponsor.name ? <div class='fw-bold mb-2'>{sponsor.name}</div> : null}
                {sponsor.code ? (
                    <div class='d-flex align-items-center gap-2 mb-3'>
                        <code class='fs-5 px-3 py-2 rounded bg-body-secondary text-body'>{sponsor.code}</code>
                        <button type='button' class='btn btn-sm btn-outline-secondary' onClick={() => this.copy(sponsor.code)}>
                            <i class={`fa-solid ${copied ? 'fa-check' : 'fa-copy'} me-1`} />
                            {copied ? <Text id='adventCalendar.copied'>Copied</Text> : <Text id='adventCalendar.copy'>Copy</Text>}
                        </button>
                    </div>
                ) : null}
                {sponsor.validUntil ? (
                    <div class='small text-body-secondary mb-3'>
                        <Text id='adventCalendar.validUntil' fields={{ date: sponsor.validUntil }}>Valid until {sponsor.validUntil}</Text>
                    </div>
                ) : null}
            </AdventTextDoor>
        );
    }
}

export default AdventSponsorDoor;
